import { render, staticRenderFns } from "./SharingForm.vue?vue&type=template&id=0201c192&scoped=true"
import script from "./SharingForm.vue?vue&type=script&lang=js"
export * from "./SharingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0201c192",
  null
  
)

export default component.exports